export default __webpack_public_path__ + "static/media/MID.d1b8ce46.jpg";